import axios from 'axios'

const INSTANCEClueId = axios.create({
  baseURL: '',
  timeout: 12000,
  // withCredentials: true
})

INSTANCEClueId.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
    console.log(config)
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

INSTANCEClueId.interceptors.response.use(
  (response) => {
    return Promise.resolve(response)
  },
  (err) => {
    return Promise.reject(err)
  }
)

export function postClueId(cid, clueid){
  let formData = new FormData()
  formData.append('cid', cid)
  formData.append('url', window.location.href)
  formData.append('referer', window.location.href)
  formData.append('type', 'default')
  formData.append('params[apply_id]', clueid)

  let data = `cid=${cid}&url=${window.location.href}&referer=${window.location.href}&type=default&params[apply_id]=${clueid}`
  return new Promise((resolve, reject) => {
    INSTANCEClueId.post('http://fp.xdf.cn/index.php', data).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/js/clueid.js